export default {
  'Hello, {{name}}!': 'Hello, {{name}}!',
  'Sorry, you are not authorized to use this application. Please log out and use another account for login or use another portal.':
    'Sorry, you are not authorized to use this application. Please log out and use another account for login or use another portal.',
  'Use another account': 'Use another account',
};
